import React, { Component } from 'react';
import { Link } from "react-router-dom"
import cookie from 'react-cookies';
import SessionUser from '../Root/session-user';

export default class Header extends Component {
  constructor(props){
    super(props);
    this.state = {
        security: cookie.load('user'),
        loading: false,
        logout: false,
    } 
  }

  handleLogout(){
    localStorage.clear();
    localStorage.setItem("user", null);
    cookie.remove('user', { path: '/' });
    window.location.href='/';
  }

  render() {
  return (
    <div className="divMenuContenedor_Panel">
      <div className="divIcoMenu_Panel">
        <ul>
          <li />
          <li />
          <li />
        </ul>
      </div>
      <span className="txtNombre_Panel">
        <Link to="/">
          <img src="/static/images/logo_exportemos.png" width="199" alt="Logo Exportemos.pe"/>
        </Link>
      </span>
      <SessionUser/>
      <div className="clear" />
    </div>
  );
  }
}
 

